export enum RegionBuildStatus {
  ACTIVE = "active",
  INACTIVE = "inactive"
}

export const PRE_GA_TAG = " Pre-GA"